import { render, staticRenderFns } from "./question.vue?vue&type=template&id=ef0401cc&scoped=true"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"
import style0 from "./question.vue?vue&type=style&index=0&id=ef0401cc&prod&lang=scss"
import style1 from "./question.vue?vue&type=style&index=1&id=ef0401cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0401cc",
  null
  
)

export default component.exports